"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.mustUpgrade = exports.shouldUpgrade = void 0;
var semver_1 = __importDefault(require("semver"));
var shouldUseTrustedInputForSegwit_1 = require("@ledgerhq/hw-app-btc/lib/shouldUseTrustedInputForSegwit");
var polyfill_1 = require("./polyfill");
var env_1 = require("../env");
function shouldUpgrade(deviceModel, appName, appVersion) {
    if ((0, env_1.getEnv)("DISABLE_APP_VERSION_REQUIREMENTS"))
        return false;
    var deps = (0, polyfill_1.getDependencies)(appName);
    if ((deps.includes("Bitcoin") &&
        (0, shouldUseTrustedInputForSegwit_1.shouldUseTrustedInputForSegwit)({
            name: appName,
            version: "1.4.0"
        })) ||
        appName === "Bitcoin") {
        // https://donjon.ledger.com/lsb/010/
        return !semver_1["default"].satisfies(semver_1["default"].coerce(appVersion) || "", ">= 1.4.0");
    }
    return false;
}
exports.shouldUpgrade = shouldUpgrade;
var appVersionsRequired = {
    Cosmos: ">= 2.14",
    Algorand: ">= 1.2.9",
    Polkadot: ">= 12.9180.0",
    Elrond: ">= 1.0.11",
    Ethereum: ">= 1.9.17",
    Solana: ">= 1.2.0"
};
function mustUpgrade(deviceModel, appName, appVersion) {
    if ((0, env_1.getEnv)("DISABLE_APP_VERSION_REQUIREMENTS"))
        return false;
    var range = appVersionsRequired[appName];
    if (range) {
        return !semver_1["default"].satisfies(appVersion, range);
    }
    return false;
}
exports.mustUpgrade = mustUpgrade;
//# sourceMappingURL=support.js.map